import { create } from "zustand";
export const useAppBarStore = create((set)=>({
        isVisible: true,
        setIsVisible: (visible)=>set({
                isVisible: visible
            })
    }));
